import { useState } from 'react';
import type { IRequestGetOne } from '../../interfaces/requestGetOne';
import { fetchJson } from '../../../store/fetch';
import { translateKey } from '../../../translate';
import { Button } from '../common';

export function GetAccessToCounselingButton(props: { reloadRequest: () => Promise<void>; request: IRequestGetOne }) {
    const [isLoading, setIsLoading] = useState(false);

    if (!props.request.authorization?.canGetAccessToCounseling) {
        return null;
    }

    return (
        <Button
            color="secondary"
            disabled={isLoading}
            large
            onClick={async () => {
                setIsLoading(true);
                const url = `/api/therapieland/${props.request.id}/getAccess`;
                await fetchJson(url, 'POST');
                await props.reloadRequest();
                setIsLoading(false);
            }}
        >
            {translateKey('request.action_getAccessToCounseling')}
        </Button>
    );
}
